import { render, staticRenderFns } from "./airRouteList.vue?vue&type=template&id=5b9a285b&scoped=true&"
import script from "./airRouteList.vue?vue&type=script&lang=js&"
export * from "./airRouteList.vue?vue&type=script&lang=js&"
import style0 from "./airRouteList.vue?vue&type=style&index=0&id=5b9a285b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a285b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9a285b')) {
      api.createRecord('5b9a285b', component.options)
    } else {
      api.reload('5b9a285b', component.options)
    }
    module.hot.accept("./airRouteList.vue?vue&type=template&id=5b9a285b&scoped=true&", function () {
      api.rerender('5b9a285b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airConfig/tabs/airRouteList.vue"
export default component.exports